import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "render", "name", "alignItems"],
  _excluded2 = ["errorMessages", "fields", "values", "hasErrors", "reset", "onSubmit"];
import React from 'react';
import PropTypes from 'prop-types';
import { FormSpy } from "./FormSpy";

/** PureComponent mean to be used inside the `Form` component.
 * It will inject its child with the appropriate state/handlers. */
import { jsx as ___EmotionJSX } from "@emotion/core";
const FormField = _ref => {
  let {
      children,
      render,
      name
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return ___EmotionJSX(FormSpy, {
    fields: [name]
  }, _ref2 => {
    let {
        errorMessages,
        fields
      } = _ref2,
      spyProps = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    return (children || render)(_extends({}, props, spyProps, fields[name], {
      errorMessages,
      name
    }));
  });
};
FormField.propTypes = {
  /** A single Field component that you want initialized in the `Form`. */
  children: PropTypes.func,
  /** A single Field component that you want initialized in the `Form`. */
  render: PropTypes.func,
  /** The name of the field you want connected to `Form` state. */
  name: PropTypes.string.isRequired
};
export { FormField };